import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'toggler' : 'open'
            }
        }
    }

    open(e) {
        e.preventDefault()

        const el = e.curTarget
        const type = this.getData('type', el)

        if (type === 'video') {

            const data = {
                id:   this.getData('id', el),
                host: this.getData('host', el),
            }

            this.call('open', data, 'ModalVideo')

            const scrollTarget = this.getData('scroll-target', el)
            if (scrollTarget) {
                setTimeout(() => {
                    this.call('scrollTo', {
                        target: scrollTarget,
                        immediate: true,
                    }, 'Scroll')
                }, 300)
            }
        }
    }
}
